// Helpers liés à la collection de l'utilisateur

// Clé composite unique pour une carte + variant dans la collection
export const getCollectionKey = (cardId, variant) => `${cardId}::${variant}`;
